import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { SuiContainer, SuiLabel, SuiPopover, SuiButton, SuiField } from '@splashthat/sui';

import CloseIcon from '../../icons/Close';

import './styles.styl';

const COLOR_PICKER_POPOVER_TITLE = 'Choose Color';
const BASE_CLASS_NAME = 'ColorPickerPopover';

export default class ColorPickerPopover extends Component {
    static propTypes = {
        showPopover: PropTypes.bool.isRequired,
        minWidth: PropTypes.number.isRequired,
        colorList: PropTypes.array.isRequired,
        anchorEl: PropTypes.object,
        onClickClose: PropTypes.func.isRequired,
        onClickChangeColor: PropTypes.func.isRequired,
        colorPickerLabel: PropTypes.string.isRequired,
        colorPickerColor: PropTypes.object.isRequired,
        getBackgroundStyle: PropTypes.func.isRequired,
        qaId: PropTypes.string.isRequired,
    };

    static defaultProps = {
        anchorEl: null,
    };

    wrapperRef = React.createRef();

    componentDidMount = () => {
        document.addEventListener('click', this.handleOutsideClick, false);
    };

    componentWillUnmount = () => {
        document.removeEventListener('click', this.handleOutsideClick, false);
    };

    handleOutsideClick = (event) => {
        if (this.wrapperRef && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.props.onClickClose();
        }
    };

    handleOnClickChangeColor = (i) => {
        this.props.onClickChangeColor(i);
        this.props.onClickClose();
    };

    render() {
        const {
            showPopover,
            minWidth,
            colorList,
            anchorEl,
            onClickClose,
            colorPickerLabel,
            colorPickerColor,
            getBackgroundStyle,
            qaId,
        } = this.props;
        const { id } = colorPickerColor;
        const colorPickerAriaLabel = colorPickerLabel ? `${colorPickerLabel} ` : '';

        return (
            <SuiPopover open={showPopover} anchorEl={anchorEl}>
                <div ref={this.wrapperRef}>
                    <SuiContainer
                        className={`${BASE_CLASS_NAME}__container`}
                        style={{
                            minWidth,
                            width: minWidth,
                        }}
                    >
                        <SuiContainer className={`${BASE_CLASS_NAME}__header`}>
                            <SuiLabel text={`${COLOR_PICKER_POPOVER_TITLE}: ${colorPickerLabel}`} />
                            <SuiButton
                                data-skip-autofocus
                                variation="navigation"
                                size="small"
                                onClick={onClickClose}
                                icon={<CloseIcon />}
                            />
                        </SuiContainer>
                        <SuiContainer className={`${BASE_CLASS_NAME}__body`}>
                            {colorList.map((color) => (
                                <div key={color.id} className={`${BASE_CLASS_NAME}__color-block`}>
                                    <SuiField
                                        formElement={
                                            <button
                                                className={`${BASE_CLASS_NAME}__body--color-button
                                                    ${color.id === id ? 'selected' : ''}`}
                                                style={{
                                                    ...getBackgroundStyle(color.value),
                                                    borderColor: color.value,
                                                }}
                                                onClick={() => this.handleOnClickChangeColor(color.id)}
                                                data-qa={`${qaId}--option-${color.id}`}
                                                aria-label={`${colorPickerAriaLabel}Color Picker - Color Option ${color.value}`}
                                            />
                                        }
                                    />
                                </div>
                            ))}
                        </SuiContainer>
                    </SuiContainer>
                </div>
            </SuiPopover>
        );
    }
}
